import { formatDateTime as formatDateTimeUserTz } from '@/utils/date';

/**
 * 실시간 모니터링용 날짜/시간 표시.
 * 서버는 UTC(ISO-Z 또는 tz 없는 UTC 문자열)로 내려주고, 화면에는 사용자의
 * 브라우저 타임존으로 변환해 표시한다. (KST 고정 금지 — 글로벌 서비스 원칙)
 */
export function formatDateTime(date: string | Date | null | undefined): string {
  return formatDateTimeUserTz(date);
}

/**
 * SensorType enum: O2LF=0, CO=1, H2S=2, LEL_LPC=3, CO2_CRANBERRY=4, LEL_IR=5, O2=6, LEL_1Series=7, CO_ALPHA=8, H2S_ALPHA=9, CO2_CRANBERRY_VOL=250
 * CO(1), H2S(2), CO_ALPHA(8), H2S_ALPHA(9)만 TWA/STEL 지원
 */
export function sensorSupportsTwaStel(sensorType: number | string | undefined): boolean {
  if (sensorType === undefined || sensorType === null) return false;
  if (typeof sensorType === 'number') {
    return sensorType === 1 || sensorType === 2 || sensorType === 8 || sensorType === 9;
  }
  const type = String(sensorType).toUpperCase();
  return type === 'CO' || type === 'H2S';
}

/**
 * LEL_LPC(3), LEL_IR(5), LEL_1Series(7)만 Custom LEL 지원
 */
export function sensorSupportsCustomLel(sensorType: number | string | undefined): boolean {
  if (sensorType === undefined || sensorType === null) return false;
  if (typeof sensorType === 'number') {
    return sensorType === 3 || sensorType === 5 || sensorType === 7;
  }
  const type = String(sensorType).toUpperCase();
  return type.includes('LEL') || type.includes('CH4');
}

/**
 * LEL_LPC(3), LEL_IR(5), LEL_1Series(7)만 Vol for 50 LEL CH4 지원
 */
export function sensorSupportsVolFor50Lel(sensorType: number | string | undefined): boolean {
  if (sensorType === undefined || sensorType === null) return false;
  if (typeof sensorType === 'number') {
    return sensorType === 3 || sensorType === 5 || sensorType === 7;
  }
  const type = String(sensorType).toUpperCase();
  return type.includes('LEL') || type.includes('CH4');
}

export function getBatteryIcon(batteryState: number | null | undefined): string {
  if (batteryState === null || batteryState === undefined) {
    return '/icons/battery-0.svg';
  }
  const iconIndex = Math.min(4, Math.max(0, batteryState));
  return `/icons/battery-${iconIndex}.svg`;
}
